// extracted by css-extract-rspack-plugin
export default {"icon":"CopyButtonCell_icon__mRdLV"};